import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose, pathEq, toPairs, filter, map, curryN } from 'ramda';
import { Container, TicketCounterLine } from './ticketsCounter.styles';

const onlyEnabled = filter(pathEq([1, 'enabled'], true));

export class TicketsCounter extends PureComponent {
  static propTypes = {
    ticketTypes: PropTypes.object,
    bookingTickets: PropTypes.object,
    ageLimits: PropTypes.object,
    updateBookingTicketCount: PropTypes.func.isRequired,
  };

  handleTicketCountChanged = curryN(2, this.props.updateBookingTicketCount);

  render() {
    return (
      <Container>
        {compose(
          map(([type, { price }]) => (
            <TicketCounterLine
              key={type}
              type={type}
              price={price}
              ageLimit={this.props.ageLimits[type]}
              count={this.props.bookingTickets[type]}
              onCountChanged={this.handleTicketCountChanged(type)}
            />
          )),
          onlyEnabled,
          toPairs
        )(this.props.ticketTypes)}
      </Container>
    );
  }
}
